// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Category$Showside from "../types/Category.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as FiltersPanel_Lazy$Showside from "./FiltersPanel_Lazy.bs.js";
import * as CustomerBombayShirts$Showside from "../customers/CustomerBombayShirts.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as LegacyShowside_CategoryDecoders$ApiTypes from "../../../../node_modules/api-types/lib/es6_global/src/LegacyShowside/LegacyShowside_CategoryDecoders.bs.js";
function ListPageMobileFilters(Props) {
  var activeCategory = Props.activeCategory;
  var connection = Props.connection;
  var isOpen = Props.isOpen;
  var isBombayshirts = CustomerBombayShirts$Showside.useIsBombay(undefined);
  var match = ViewportContext$Showside.use(undefined);
  var isMobile = match.isMobile;
  var match$1 = RouterProvider$Showside.useRouter(undefined);
  var appliedFilters = match$1.productFilters;
  var appliedSort = match$1.productSort;
  var match$2 = ConfigurationProvider$Showside.use(undefined);
  var settings = match$2.config.settings;
  var match$3 = settings.indexNode;
  var parentCategory = activeCategory !== undefined ? activeCategory : match$3 !== undefined ? match$3 : LegacyShowside_CategoryDecoders$ApiTypes.empty;
  var match$4 = settings.indexNode;
  var connection$1 = connection !== undefined ? connection : match$4 !== undefined ? Category$Showside.ExternalConnection.getStoreCategoryConnection(match$4) : undefined;
  return Belt_Option.mapWithDefault(connection$1, null, function (connection) {
    if (isMobile || isBombayshirts) {
      return React.createElement(React.Fragment, undefined, React.createElement(FiltersPanel_Lazy$Showside.make, {
        connection: connection,
        panelSize: settings.panelSize,
        isOpen: isOpen,
        fullscreen: true,
        enabledSort: isMobile,
        appliedFilters: appliedFilters,
        appliedSort: appliedSort,
        zIndex: settings.zIndexInt,
        key: parentCategory.id
      }));
    } else {
      return null;
    }
  });
}
ListPageMobileFilters.displayName = "ListPageMobileFilters";
var make = ListPageMobileFilters;
export { make };
/* react Not a pure module */